import { Navigation, Router } from '@angular/router';
import { environment } from './../../environments/environment';
import { State } from './../state.model';
import { NavigationService } from './../navigation.service';

import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Attribution } from '../attribution.modal';

@Component({
  selector: 'app-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent implements OnInit {
  progress: Observable<any>;
  private _state = {};
  private _prevState = {};
  private _progress;
  private _prevProgress;
  wp = environment.wp;
  lastAction: any;
  attribution: Attribution = {
    lead_page: '',
    lead_type: '',
    lead_utm_campaign: '',
    lead_utm_term: '',
    lead_utm_content: '',
    lead_utm_name: '',
    lead_utm_medium: '',
    lead_source: '',
  };
  constructor(public nav: NavigationService, private router: Router) { }

  ngOnInit() {
    this.progress = this.nav.progress$;
    this.progress.subscribe(p => {
      this._prevProgress = this._progress;
      this._progress = p;
      if (this._progress < this._prevProgress) {
        // updating the state to remove previous step
        if (this._progress === 15) {
          this.nav.refreshState({});
        }
        else if (this._progress === 29) {
          const newState = (({ choice }) => ({ choice }))(this.nav.state);
          this.nav.refreshState(newState);
          this.nav.updateState('busRes', '');
          this.nav.updateState('howMuch', '');
          this.nav.updateState('witness', '');
          this.nav.updateState('howOften', '');
        }
        else if (this._progress === 42) {
          this.nav.updateState('howMuch', '');
          this.nav.updateState('witness', '');
          this.nav.updateState('howOften', '');
        }
        else if (this._progress === 57) {
          this.nav.updateState('witness', '');
          this.nav.updateState('howOften', '');
        }
        else if (this._progress === 71) {
          this.nav.updateState('howOften', '');
        }
      }
    });
    this.nav.state$.subscribe(s => {
      this._prevState = this._state;
      if(s){
        this._state = {...s as {}};
      }
    });
    this.nav.lastAction$.subscribe(a => {
      this.lastAction = a;
    });
  }

  goToAction() {
    if (this.lastAction) {
      this.router.navigate(['action', this.lastAction]);
    } else {
      console.log('please wait!');
    }
  }

  getState() {
    return this._state;
  }

  setAttribution(key: string, value: string) {
    this.attribution[key] = value;
  }

}
